import { enablePageScroll } from 'scroll-lock';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('enablePageScroll', enablePageScroll)
})